import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "toast-container",
  role: "region",
  "aria-live": "polite",
  "aria-label": "Notifications"
}
const _hoisted_2 = ["onClick", "aria-describedby"]
const _hoisted_3 = { class: "toast-content" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = ["id"]
const _hoisted_10 = ["onClick", "aria-label"]

import { useToast } from "@/composables/useToast";


export default /*@__PURE__*/_defineComponent({
  __name: 'ToastContainer',
  setup(__props) {

const { toasts, removeToast } = useToast();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_unref(toasts).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_TransitionGroup, {
            name: "toast",
            tag: "div"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toasts), (toast) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: toast.id,
                  class: _normalizeClass(['toast', `toast-${toast.type}`]),
                  onClick: ($event: any) => (_unref(removeToast)(toast.id)),
                  role: "alert",
                  "aria-describedby": `toast-message-${toast.id}`
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", {
                      class: "toast-icon",
                      "aria-label": `${toast.type} notification`
                    }, [
                      (toast.type === 'success')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "✓"))
                        : (toast.type === 'error')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "✕"))
                          : (toast.type === 'warning')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "⚠"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_8, "ℹ"))
                    ], 8, _hoisted_4),
                    _createElementVNode("div", {
                      class: "toast-message",
                      id: `toast-message-${toast.id}`
                    }, _toDisplayString(toast.message), 9, _hoisted_9),
                    _createElementVNode("button", {
                      class: "toast-close",
                      onClick: _withModifiers(($event: any) => (_unref(removeToast)(toast.id)), ["stop"]),
                      "aria-label": `Close ${toast.type} notification`
                    }, " × ", 8, _hoisted_10)
                  ])
                ], 10, _hoisted_2))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})